// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1STbk","list":"styles_list__13wGo"};